<div class="cr7_force_case__images_main_container">
    <div class="cr7_force_case__body_posture_container">
        <div class="cr7_force_case__body_posture_label_container">
            <label class="cr7_force_case__body_posture_label">
                {{ 'PAGE.MM_07.POSTURE.LBL' | translate | uppercase }}
                <span *ngIf="isRequired">*</span>
            </label>
            <sera-toggle
                [isDisabled]="readOnly"
                [toggleValue]="isToShowInputForBodyPosture"
                (toggleChange)="handleBodyPostureToggleChange($event)"
                [label]="'PAGE.MM_07.ACTIVATE.LBL' | translate"
                *ngIf="isToShowBodyPostureToggle"></sera-toggle>
        </div>
        <div class="images_placeholder_container">
            <div
                class="images_placeholder_container__images_container"
                *ngFor="let posture of postureItems">
                <sera-image
                    [readOnly]="readOnly"
                    [imageItem]="posture.image"
                    (imageClickEmitter)="handleBodyPostureClick(posture.defPostureId)">
                </sera-image>
                <sera-input-number
                    [readOnly]="readOnly"
                    [styleFloatLabel]="this.isInvalid ? 'invalid' : ''"
                    [placeholder]="'PAGE.GENERAL.RISK_VALUE.LBL' | translate"
                    [ngModel]="posture.percentage"
                    [max]="100"
                    [min]="0"
                    (inputNumberBlur)="handleBodyPosturePercentageBlur($event, posture)"
                    *ngIf="isToShowInputForBodyPosture"
                    [autoWidth]="true">
                </sera-input-number>
            </div>
        </div>
    </div>
</div>
